import { getOutStore, loadOutStoreInSalesStat, getOutStoreStat } from '@/api/outStore'
import Vue from 'vue'

const state = {
  entityList: [],
  outStoreStat:[],
  totalCounts: 0
}

const actions = {
  async getOutStoreAction({ commit }, payload) {
    try {
      const res = await getOutStore(payload)
      commit('SET_OUT_STORE', res.data)
      return res.data
    } catch (error) {
      throw error.message
    }
  },

  async getOutStoreStatAction({ commit }, payload) {
    try {
      const res = await getOutStoreStat(payload)
      commit('SET_OUT_STORE_STAT', res.data)
      return res.data
    } catch (error) {
      throw error.message
    }
  },

  async loadOutStoreInSalesStatAction({ commit }, payload) {
    try {
      const res = await loadOutStoreInSalesStat(payload)
      // commit('LOAD_OUT_STORE_INSALES_STAT', res.data)
      return res.data
    } catch (error) {
      throw error.message
    }
  },
}

const mutations = {
  SET_OUT_STORE(state, outstore) {
    state.entityList = outstore.entityList
    state.totalCounts = outstore.totalCounts
  },
  SET_OUT_STORE_STAT(state, outstore) {
    state.outStoreStat = outstore.outStoreStat
  },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}